/*eslint-disable*/
import React from "react";
//import logo from './logo.svg';
//import './App.css';
import FileUploader from "../../components/FileUploader";
function UploadFile() {
  return <FileUploader />;
}
export default UploadFile;
